var delayMs = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
var randomNumber = function () { return Math.random(); };

export { delayMs, randomNumber };
